export const isLoadingReducer = (requestTypes) => (state = false, action) => {
  switch (action.type) {
    case requestTypes['REQUEST']:
      return true;
    case requestTypes['SUCCESS']:
    case requestTypes['FAILURE']:
      return false;
    default:
      return state;
  }
};

export const loadedQueryReducer = (requestTypes) => (state = null, action) => {
  switch (action.type) {
    case requestTypes['SUCCESS']:
      return action.payload.query;
    case requestTypes['REQUEST']:
    case requestTypes['FAILURE']:
      return null;
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/helpers.js